import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import type { UserState } from '../store/user.slice';

export function useUserData(): UserState {
    return useSelector((state: RootState) => state.user);
}
